import { SmsItem } from '../interfaces/sms-item.interface';
import { WorkItemBold } from './workitem-bold';
import { WorkItemTypes } from '../constants/workitem-types';

export class WorkItemSms extends WorkItemBold implements SmsItem {
  public readonly type: string = WorkItemTypes.SMS;
  public messageInitialLoadIsFinished: boolean;

  Name: string;
  Created?: string;
  IsAnswered?: boolean;

  constructor(workItem) {
    super(workItem);

    this.keepAlive = false;
  }
}
